import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import {
    effectMenuConfig,
} from '@framework/workbench/ui/transition/transition-effect-option/menu-config';
import * as React from 'react';

export const config = {
    id: ActionType.TRANSITION_EFFECT_OPTION,
    content: i18n.t('效果选项'),
};

export const toolbarConfig = {
    id: ActionType.TRANSITION_EFFECT_TOOLBAR,
    content: config.content,
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: toolbarConfig.id,
        style: {
            width: 'auto',
        },
        text: toolbarConfig.content,
        tooltip: toolbarConfig.content,
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        tooltip: config.content,
    },
    {
        name: toolbarConfig.id,
        content: '',
    },
    ...effectMenuConfig,
];


